import axios from "axios";
import { API_URL } from "../constants";

export type OpportunityOutcome = "WON" | "LOST" | "DELETED";

export type OpportunityHistoryEntry = {
  id: string;
  name: string;
  outcome: OpportunityOutcome | null;
  outcomeAt: number | null;
  valueEur: number | null;
  contactName: string | null;
  contactEmail: string | null;
  user: { id: string; name: string | null } | null;
  customer: { id: string; name: string | null } | null;
  boardId: string | null;
  boardName: string | null;
  columnId: string | null;
  columnName: string | null;
};

export type OpportunityHistoryCounts = {
  all: number;
  WON: number;
  LOST: number;
  DELETED: number;
};

export type OpportunityHistoryParams = {
  outcome?: "all" | OpportunityOutcome;
  dateFrom?: string;
  dateTo?: string;
  boardId?: string;
  page?: number;
  pageSize?: number;
};

export async function fetchOpportunityHistory(
  companyId: string,
  params: OpportunityHistoryParams = {}
): Promise<{
  entries: OpportunityHistoryEntry[];
  pagination: {
    total: number;
    page: number;
    pageSize: number;
    totalPages: number;
  };
  counts: OpportunityHistoryCounts;
}> {
  const res = await axios.get(
    `${API_URL}/${companyId}/projects/opportunity-history`,
    { params }
  );
  return res.data;
}
